import { graphql } from "@opensea/graphql"
import {
  MintTableRowCollectionFragment,
  MintTableRowDropFragment,
} from "./MintTableRow.fragment"

export const MintTableCollectionFragment = graphql(
  `
    fragment MintTableCollection on Collection {
      id
      ...MintTableRowCollection
    }
  `,
  [MintTableRowCollectionFragment],
)

export const MintTableDropFragment = graphql(
  `
    fragment MintTableDrop on Drop {
      ...MintTableRowDrop
    }
  `,
  [MintTableRowDropFragment],
)
